<template>
  <div class="select-chart-container" :id="id">
    <v-row>
      <div class="position-absolute" style="top: 15px; right: 25px">
        <DownloadChartButton :id="id" />
      </div>
      <v-col class="py-8" cols="12">
        <ChartTitle :title="title"></ChartTitle>
      </v-col>
    </v-row>



    <v-col v-if="showColorCode" cols="12">
      <AverageScore
        colorTable="gradientColors"
        :gradientColors="gradientColors"
      ></AverageScore>
    </v-col>

    <v-col cols="12">
      <BarChart
        v-if="chartData"
        :chartData="Utils.methods.deepCopy(chartData)"
        :options="chart.options"
        :aspectRatio="aspectRatio"
      >
      </BarChart>
    </v-col>
  </div>
</template>

<script setup>
import BarChart from "../base/BarChart.vue";
import ChartTitle from "../components/ChartTitle.vue";
import AverageScore from "../components/AverageScore.vue";
import Exporter from "vue-chartjs-exporter";
import { computed } from "vue";
import Utils from "../../Mixins/Utils";
import DownloadChartButton from "@/Charts/components/DownloadChartButton.vue";

const props = defineProps({
  title: {
    type: String,
    default: null,
    required: false,
  },
  chartData: {
    type: Object,
    required: true,
  },
  gradientColors: {
    type: Array,
    required: false,
  },
  showColorCode: {
    type: Boolean,
    required: false,
    default: true,
  },
  axisLabels: {
    type: Object,
    required: false,
    default: function () {
      return { x: "", y: "" };
    },
  },
  aspectRatio: {
    type: Object,
    required: false,
    default: function () {
      return { width: 3, height: 1 };
    },
  },
  showChartLegend: {
    type: Boolean,
    required: false,
    default: false,
  },
  id: {
    type: String,
    required: false,
  },
});

const chart = computed(() => {
  return {
    aspectRatio: 1,
    maintainAspectRatio: false,
    options: {
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: {
            color: '#1e1e1e',
            font: (context) => {
              const label = context.tick.label;
              let size = 15;
              if (Array.isArray(label)) {
                if (label.length > 3) size = 10;
                else if (label.length > 2) size = 12;
                else if (label.length > 1) size = 14;
              } else if (label && label.length > 20) {
                size = 12;
              }
              return {
                size: size
              };
            },
          },
        },
        y: {
          max: 5,
          ticks: {
            beginAtZero: true,
            color: '#1e1e1e',
            font: {
              size: 15,
            },
          },
        },
      },
    },
  };
});

function printChart(id) {
  //Disappear the button
  let graphical = document.getElementById(id);
  const exp = new Exporter([graphical]);
  exp.export_pdf().then((pdf) => pdf.save("charts.pdf"));
}
</script>

<style scoped></style>
